<template>
  <div>
    <button class="button full-100 is-primary" @click="handlePlayOnWeb()">
      {{ $t('playGameBtn') }}
    </button>
  </div>
</template>

<script>
import apiAutoLogin from '@/api/auto.login'
// import open from 'open'

export default {
  name: 'LoginSlotRacha',
  props: {
    url: {
      type: String
    },
    account: {
      type: Object
    },
    trigger: {
      type: Number
    }
  },
  watch: {
    trigger: {
      // immediate: true,
      async handler() {
        this.handlePlayOnWeb()
      }
    }
  },
  methods: {
    handlePlayOnWeb() {
      apiAutoLogin
        .slotracha(this.account.username, this.account.password)
        .then(response => {
          if (process.env.VUE_APP_IFRAME === 'true') {
            const a = document.createElement('a')
            a.setAttribute('href', response.link)
            a.setAttribute('target', '_blank')
            a.click()
            document.body.appendChild(a)
          } else window.location.href = response.link
        })
    }
  }
}
</script>

<style scoped lang="scss">
.height-0 {
  height: 0px !important;
  visibility: hidden;
}
</style>
